// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ffd50007","27":"bdc24671","84":"806de563","147":"81a49353","362":"2243b076","574":"ff17616b","807":"66724617","818":"39f2d371","899":"255d468a","900":"bbec8e99"}[chunkId] + ".chunk.js";
};